__turbopack_context__.v({
  "bottomJustifiedContainer": "SubmitButton-module-scss-module__bxq1Cq__bottomJustifiedContainer",
  "btn": "SubmitButton-module-scss-module__bxq1Cq__btn",
  "btn-alt": "SubmitButton-module-scss-module__bxq1Cq__btn-alt",
  "btn-default": "SubmitButton-module-scss-module__bxq1Cq__btn-default",
  "btn-default-dark-bg": "SubmitButton-module-scss-module__bxq1Cq__btn-default-dark-bg",
  "btn-disabled": "SubmitButton-module-scss-module__bxq1Cq__btn-disabled",
  "btn-elite": "SubmitButton-module-scss-module__bxq1Cq__btn-elite",
  "btn-gold": "SubmitButton-module-scss-module__bxq1Cq__btn-gold",
  "btn-lg": "SubmitButton-module-scss-module__bxq1Cq__btn-lg",
  "btn-link": "SubmitButton-module-scss-module__bxq1Cq__btn-link",
  "btn-plat": "SubmitButton-module-scss-module__bxq1Cq__btn-plat",
  "btn-primary": "SubmitButton-module-scss-module__bxq1Cq__btn-primary",
  "btn-sm": "SubmitButton-module-scss-module__bxq1Cq__btn-sm",
  "btn-success": "SubmitButton-module-scss-module__bxq1Cq__btn-success",
  "btn-warning": "SubmitButton-module-scss-module__bxq1Cq__btn-warning",
  "defaultWrapInner": "SubmitButton-module-scss-module__bxq1Cq__defaultWrapInner",
  "defaultWrapOuter": "SubmitButton-module-scss-module__bxq1Cq__defaultWrapOuter",
  "disabled": "SubmitButton-module-scss-module__bxq1Cq__disabled",
  "disabledBtn": "SubmitButton-module-scss-module__bxq1Cq__disabledBtn",
  "hideForMobile": "SubmitButton-module-scss-module__bxq1Cq__hideForMobile",
  "stickyBttn": "SubmitButton-module-scss-module__bxq1Cq__stickyBttn",
  "stickyButtonWrap": "SubmitButton-module-scss-module__bxq1Cq__stickyButtonWrap",
});
